import {
  useEffect,
  useCallback,
  useRef,
} from 'react';

const useTextSelection = (callback, deps) => {
  const callbackRef = useRef();

  useEffect(() => {
    callbackRef.current = callback;
  }, [...deps]);

  const selectstartCb = useCallback(() => {
    document.addEventListener('mouseup', callbackRef.current, { once: true });
  }, []);

  useEffect(() => {
    document.addEventListener('selectstart', selectstartCb);

    return () => {
      document.removeEventListener('selectstart', selectstartCb);
    };
  }, [selectstartCb]);
};

export default useTextSelection;
